module.exports = __webpack_public_path__ + "assets/img/ic-intro-gift.a07ec8b5.png";